module.exports = __webpack_public_path__ + "img/video6.5966b698.jpg";